// **************** ROUTE CONSTANT START **************************
// General Page Section
export const ACCOUNTS = '/accounts';
export const STORES = '/stores';
export const CARTS = '/carts';
export const USERS = '/usuarios';
export const LOGIN = '/login';

// **************** ROUTE CONSTANT END **************************

export const GLOBAL_LIMIT = 20;
export const DEFAULT_DDI = '55';
